import { Component, OnInit } from '@angular/core';
import {ActionBarService} from '../action-bar.service';

@Component({
  selector: 'mes-web-action-bar-list-buttons',
  templateUrl: './action-bar-list-buttons.component.html'
})
export class ActionBarListButtonsComponent implements OnInit {

  constructor(public actionBarService: ActionBarService) { }

  ngOnInit() {
  }

}
